module.exports = __webpack_public_path__ + "img/confetti-left.5bd40d7f.svg";